export default __webpack_public_path__ + "static/media/detail_mobile_14_3.a0a16a89.jpg";